import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import BaseModal from "../../theme/modals/BaseModal";
import validators from "../../../utils/forms/validators";
import Input from "../../theme/forms/Input";


// NEED TO AUTHENTICATE HERE, AND CONFIRM EMAIL

function SignatureModal({onSign, onCancel, title}) {

    const [digitalSignatureDisclaimerAccepted, setDigitalSignatureDisclaimerAccepted] = useState(false);
    const [signatureValue, setSignatureValue] = useState(null);

    const userData = useSelector(state => state.user?.decodedTokenData || {})

    const canAccept = () => {
         return digitalSignatureDisclaimerAccepted &&
             signatureValue &&
             signatureValue.length > 3 &&
             userData.user_id
    }

    const onSignatureAccept = () => {
        let data = {
            digitalSignatureAccepted: digitalSignatureDisclaimerAccepted,
            signedTime: new Date().toISOString(),
            signatureValue,
            user: userData
        }

        return onSign(data)
    }



    return (
         <BaseModal visible>
                <div className="mb-4">
                    {title}
                </div>
                <div className="is-flex my-4">

                    <span
                        className="mr-3"
                        onClick={() => setDigitalSignatureDisclaimerAccepted(!digitalSignatureDisclaimerAccepted)}>
                        {digitalSignatureDisclaimerAccepted ?
                            <i className="fas fa-check-square has-text-success"/> :
                            <i className="far fa-square"/>}
                    </span>
                    <p className="">
                    By selecting the "I Agree" button, I am signing this document electronically. I agree that my electronic signature is the legal equivalent of my manual/handwritten signature for this submission. I also agree to bind myself to a non-circumvent condition with regard to any dealing with any investor relationship that might come out of this process. I also agree that my signature on this document is as valid as if I signed the document in writing, and confirm that I am authorized to enter this project into BidDesk and to enter into any EPC agreement that might follow.
                    </p>

                </div>

                {!userData.user_id &&
                <p className="has-text-danger my-6">Your authentication is currently invalid so you cannot sign.</p>
                }

                <div className="my-5">
                    <p className="has-text-weight-semibold mb-2">Please type your full name below to sign</p>
                    <Input
                        type="text"
                        value={signatureValue}
                        onChange={val => setSignatureValue(val)}
                        placeholder="John W. Smith"
                        classNames="is-medium"
                        {...validators.isStringOfMinLength(3)}
                    />
                </div>
                <div className="buttons">
                    <button
                        onClick={onCancel}
                        className="button is-danger">
                        Cancel
                    </button>
                     <button
                         onClick={onSignatureAccept}
                         className={`button is-primary ${canAccept() ? '' : 'disabled'}`}>
                         Sign
                     </button>
                </div>

            </BaseModal>
    )
}

export default SignatureModal